import React, { useEffect } from 'react';

import * as S from './styled';

interface Props {
  isOpen: boolean;
  onDismiss: () => void;
  onCloseAndContinue: () => void;
  onSubscribe: () => void;
  email: string;
  getText: (key: string) => string;
}

export const OutOfStockModal = ({ isOpen, onDismiss, onCloseAndContinue, onSubscribe, email, getText }: Props) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const closeByEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onDismiss();
      }
    };

    window.addEventListener('keydown', closeByEscape);

    return () => {
      window.removeEventListener('keydown', closeByEscape);
    };
  }, [isOpen, onDismiss]);

  if (!isOpen) {
    return null;
  }

  return (
    <S.ModalOverlay onClick={onDismiss} role="presentation">
      <S.ModalCard onClick={event => event.stopPropagation()}>
        <S.ModalTitle>{getText('payment_text_369')}</S.ModalTitle>
        <S.ModalCloseButton type="button" onClick={onCloseAndContinue} aria-label="Close out of stock dialog">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
            <path d="M12.001 4L4.0016 11.9994" stroke="#221E1A" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M4 4L11.9994 11.9994" stroke="#221E1A" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </S.ModalCloseButton>

        <S.ModalText dangerouslySetInnerHTML={{ __html: getText('payment_text_370') }} />
        <S.ModalText dangerouslySetInnerHTML={{ __html: getText('payment_text_371') }} />

        <S.EmailField type="email" readOnly value={email} aria-label="User email" />

        <S.PrivacyRow>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="none">
            <path
              d="M12 6.5V4.96154V4.5C12 2.84314 10.6569 1.5 9 1.5C7.34315 1.5 6 2.84314 6 4.5V4.96154V6.5"
              stroke="#29A073"
              strokeWidth="1.5"
            />
            <rect x="2.75" y="6.5" width="12.5" height="7.5" rx="2.25" stroke="#29A073" strokeWidth="1.5" />
          </svg>
          <S.PrivacyText dangerouslySetInnerHTML={{ __html: getText('payment_text_261') }} />
        </S.PrivacyRow>

        <S.SubscribeButton type="button" onClick={onSubscribe}>
          {getText('payment_text_372')}
        </S.SubscribeButton>
      </S.ModalCard>
    </S.ModalOverlay>
  );
};
